import React, { useState, useEffect } from "react";

function OHGTd({ dataHeader, onClick, activeTime, edit }: any) {
  const [active, setactive] = useState(false);

  useEffect(() => {
    setactive(activeTime);
  }, [activeTime]);

  const handleClick = () => {
    if (edit) {
      setactive(!active);
      onClick({ ...dataHeader, active: !active });
    }
  };

  return (
    <td className="px-2 py-2 text-center">
      <button
        onClick={handleClick}
        disabled={!edit}
        className={`w-8 h-8 rounded-lg transition-all ${
          active
            ? "bg-emerald-500 shadow-md shadow-emerald-200"
            : "bg-slate-200"
        } ${
          edit
            ? "cursor-pointer hover:scale-110"
            : "cursor-default"
        }`}
      />
    </td>
  );
}

export default OHGTd;
